import { render, staticRenderFns } from "./viewProductGallery.vue?vue&type=template&id=939bc390"
import script from "./viewProductGallery.vue?vue&type=script&lang=js"
export * from "./viewProductGallery.vue?vue&type=script&lang=js"
import style0 from "./viewProductGallery.vue?vue&type=style&index=0&id=939bc390&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports